import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import Whatsapp from "../components/Whatsapp";

const Footer = () => {
  return (
    <div>
      <div className="gvr-footer">
        <Container>
          <Row className="justify-content-center">
            <Col md={12} xs={12} className="text-center">
              <h3 className="text-white">
                Hive Employee Transportation And Cab Services
              </h3>
            </Col>
          </Row>

          <Row className="justify-content-center mt-30">
            <Col md={7} xs={12}>
              <ul>
                <li><Link to="/">Home</Link></li>
                <li><Link to="/about-us">About Us</Link></li>
                <li><Link to="/our-services">Our Services</Link></li>
                <li><Link to="/safety-standards">Safety standards</Link></li>
                <li><Link to="/our-fleets">Our Fleets</Link></li>
                <li><Link to="/contact-us">Contact Us</Link></li>
              </ul>
            </Col>
          </Row>
        </Container>
      </div>

      <Row className="justify-content-center">
        <Col md={12} xs={12} className="text-center">
          <div className="copy-footer text-center">
            <p>
              All Rights Reserved 2026 © Hive Employee Transportation And Cab Services.
            </p>
          </div>
        </Col>
      </Row>

      <Whatsapp />
    </div>
  );
};

export default Footer;
